/** Russian plural form: declOfNum(5, ['день', 'дня', 'дней']) === 'дней' */
export const declOfNum = (n: number, titles: readonly [string, string, string]): string => {
  if (n % 10 === 1 && n % 100 !== 11) {
    return titles[0]
  }
  if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
    return titles[1]
  }
  return titles[2]
}
